// frontend/src/lib/report-severity.ts
import type { ReportSeverity } from './api';

// Plain-language severity choice for the report flow -- issue #17's own
// acceptance criterion: "in plain, non-alarming language, not a
// dropdown of legalese". Mirrors backend/internal/domain/report.go's
// two Severity values exactly (SeverityRoutine/SeveritySevere).
export const SEVERITY_OPTIONS: { value: ReportSeverity; label: string; description: string }[] = [
  {
    value: 'routine',
    label: 'Something seems off',
    description: "We'll review this within a day. Use this for most reports.",
  },
  {
    value: 'severe',
    label: 'This needs urgent attention',
    description: 'Use this for anything that made you feel unsafe. Our team is alerted right away.',
  },
];
